module.exports = __webpack_public_path__ + "img/power-plug-off-outline.e4a0a6a5.svg";